import { Parser } from 'expr-eval';
import { FieldDefinition, DATATYPE, METRICTYPE } from 'src/utils/entityDefinitions/entityDefinitionTypes';

const expressionParser = new Parser();

export const BEACONPRO_PROMOTION_FIELDS: {
  [key: string]: FieldDefinition;
} = {
  retailPriceDelta: {
    name: 'retailPriceDelta',
    displayName: 'Average Discount Numerator',
    dataType: DATATYPE.INTEGER,
    metricType: METRICTYPE.MONEY,
    aggregationFunction: 'avg',
    canBeExported: true
  },

  retailPrice: {
    name: 'retailPrice',
    displayName: 'Average Discount Denominator', // Discounted price
    dataType: DATATYPE.INTEGER,
    metricType: METRICTYPE.MONEY,
    aggregationFunction: 'avg',
    canBeExported: true
  },

  // ! This is a computed field
  averagePromotionDiscount: {
    name: 'averagePromotionDiscount',
    displayName: 'Average Discount',
    dataType: DATATYPE.INTEGER,
    metricType: METRICTYPE.PERCENT,
    aggregationFunctionType: 'computed',
    aggregationFunction: expressionParser.parse(
      'retailPrice-retailPriceDelta > 0 ? (retailPriceDelta/(retailPrice-retailPriceDelta)) : 0'
    )
  },

  promoType: {
    name: 'promoType',
    displayName: 'Promotion Type',
    dataType: DATATYPE.TEXT,
    metricType: METRICTYPE.TEXT,
    canBeExported: true
  },

  retailPricePrev: {
    name: 'retailPricePrev',
    displayName: 'Original Price',
    dataType: DATATYPE.INTEGER,
    metricType: METRICTYPE.MONEY,
    aggregationFunction: 'avg',
    canBeExported: true
  },

  unitsSoldPrev: {
    name: 'unitsSoldPrev',
    displayName: 'unitsSoldPrev',
    dataType: DATATYPE.INTEGER,
    metricType: METRICTYPE.VOLUME,
    aggregationFunction: 'sum',
    canBeExported: true
  },

  // ! This is a computed field
  shareOfUnitsSold: {
    name: 'shareOfUnitsSold',
    displayName: 'Share of Units Sold',
    dataType: DATATYPE.INTEGER,
    metricType: METRICTYPE.PERCENT,
    aggregationFunctionType: 'computed',
    aggregationFunction: expressionParser.parse('unitsSoldPrev > 0 ? (unitsSold/unitsSoldPrev) : 0')
  },

  retailSalesPrev: {
    name: 'retailSalesPrev',
    displayName: 'retailSalesPrev',
    dataType: DATATYPE.INTEGER,
    metricType: METRICTYPE.MONEY,
    aggregationFunction: 'sum',
    canBeExported: true
  },

  retailSalesDelta: {
    name: 'retailSalesDelta',
    displayName: 'Retail Sales Delta',
    dataType: DATATYPE.INTEGER,
    metricType: METRICTYPE.MONEY,
    aggregationFunction: 'sum',
    canBeExported: true
  },

  promotionPercentChange: {
    name: 'retailSalesDelta',
    displayName: 'Promotion Percent Change',
    dataType: DATATYPE.INTEGER,
    metricType: METRICTYPE.PERCENT,
    aggregationFunctionType: 'computed',
    aggregationFunction: expressionParser.parse('retailSalesPrev > 0 ? (retailSalesDelta/retailSalesPrev) : 0')
  },

  // ! This is a computed field
  shareOfRetailSales: {
    name: 'shareOfRetailSales',
    displayName: 'Share of Retail Sales',
    dataType: DATATYPE.INTEGER,
    metricType: METRICTYPE.PERCENT,
    aggregationFunctionType: 'computed',
    aggregationFunction: expressionParser.parse('retailSalesPrev > 0 ? (retailSales/retailSalesPrev) : 0')
  },

  // Similar to product field but with a different aggregation function.
  // Used to display the number of promotions for a product within the promotion metric cards.
  productPromotionCount: {
    name: 'stacklineSku',
    displayName: 'Product Promotion Count',
    dataType: DATATYPE.INTEGER,
    metricType: METRICTYPE.VOLUME,
    aggregationFunction: 'value_count',
    canBeExported: true
  },

  retailSalesOld: {
    name: 'retailSalesOld',
    displayName: 'Retail Sales Old',
    dataType: DATATYPE.INTEGER,
    metricType: METRICTYPE.MONEY,
    aggregationFunctionType: 'computed',
    aggregationFunction: expressionParser.parse('retailSales - retailSalesDelta'),
    canBeExported: true
  }
};
